"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortWebinarSessions = exports.dateFormatter = void 0;
var _dates = require("../_utils/dates");
// interface for WebinarSidebar session

/**
 * Sort array of webinar session by date (Asc)
 * @param {array} webinarSessions - Array of sessions
 */
var sortWebinarSessions = function sortWebinarSessions(webinarSessions) {
  var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';
  var orderedWebinars = webinarSessions.sort(function (a, b) {
    return new Date(a.sessionDateTime).getTime() - new Date(b.sessionDateTime).getTime();
  });
  if (sort === 'desc') orderedWebinars.reverse();
  return orderedWebinars;
};

/**
 * Returns an object with date parameters. Format date to be as expected for webinars
 * @param {string} date - string which contains date (timestamp)
 * @param {string} timezone - string which contains the timezone
 */
exports.sortWebinarSessions = sortWebinarSessions;
var dateFormatter = function dateFormatter(date, timezone) {
  // Not ideal, but default to current time if timestamp is not provided.
  // get substring from date avoiding timezone
  var sessionDate = (0, _dates.formatDateTo)(date, 'EEE, MMMM d, yyyy');
  var presentedSessionDate = (0, _dates.formatDateTo)(date, 'MMMM d, yyyy');
  var sessionTime = "".concat((0, _dates.formatDateTo)(date, 'h:mm a'), " ").concat(timezone);
  return {
    date: sessionDate,
    presentedDate: presentedSessionDate,
    time: sessionTime
  };
};
exports.dateFormatter = dateFormatter;